import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { COMPANY_DATA } from '../../../data/company.data';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-products-page',
  standalone: true,
  imports: [RouterLink,DecimalPipe],
  templateUrl: './sustainability-preview.component.html',
  styleUrl: './sustainability-preview.component.scss'
})
export class ProductsPageComponent {
 
  products = COMPANY_DATA.products;
  @Input() category: any = null;  
   @Output() closed = new EventEmitter<void>();   
   close(): void {     this.closed.emit();   }
 
  selectedCategory: any = null;
  
 
  openCategory(category: any): void {
    console.log(category);
    this.selectedCategory = category;
    document.body.style.overflow = 'hidden';
  }
 
  closeCategory(): void {
    this.selectedCategory = null;
    document.body.style.overflow = '';
  }
}
